import React,{useState,useEffect, useContext} from 'react';
import {useNavigate} from 'react-router-dom'
import {Passaggio} from '../App';
import '../Locali/Locali.css'

const Locali = () => {
    const link=useNavigate()
    const Contesto = useContext(Passaggio)
    const [locali,setlocali]=useState([])
    let vettoreLocali=[]

    useEffect(() => {
        //Se non ho id della città salvato, vado direttamente all'inizio (/) per evitare pagine bianche e vuote
        if(Contesto.idCitta===undefined){
            link("/")
        }else{
            //Se invece ho l'ID faccio la fetch del login
            ScaricaLocali();
        }
    }, [])

    const passaCibi=(id)=>{
        //Passo id del locali alla funzione e lo salvo in sessionStorage
        // Contesto.setidLocale(id)
        sessionStorage.setItem('idLocale', id)
        link("/cibi")
    }
    //Fetch per scaricare i locali
    const ScaricaLocali=()=>{
        //Grazie all'ID che ho salvato nel sessionStorage, posso costruire l'URL per collegarmi alla pagina dei locali corrispondente alla città corretta
        let url="http://37.60.34.42:8080/getLocali?citta="+sessionStorage.getItem('idCitta')
        fetch(url)
        .then(response=>response.json())
        .then(data=>{
            vettoreLocali=[]
            data.forEach(element => {
                vettoreLocali.push(
                    //Info relative ai locali
                    <div key={element.id} className='pulsante' onClick={()=>passaCibi(element.id)} >
                        <div className='formattatesto'>
                            {element.nome}
                        </div>
                        <div className='formattainfo'>
                            INDIRIZZO: {element.indirizzo}
                        </div>
                        <div className='formattainfo'>
                            TELEFONO: {element.telefono}
                        </div>
                        <div className='formattainfo'>
                            EMAIL: {element.email}
                        </div>
                    </div>
                )
            });
            setlocali(vettoreLocali)
        })
    }
    //Visualizzo locali
    return (
        <div id='contLocali'>
            {locali}
        </div>
    )
}

export default Locali
